import React, { useEffect, useState } from 'react'
import { useI18n } from '../../i18n/I18nContext'
import { getEnvironment, setEnvironment, type EnvironmentState, type AppEnvironment } from '../../services/environment'

const copy = {
  en: { legend: 'Environment', main: 'Main', mainHint: 'Your organization’s live data', demo: 'Demo', demoHint: 'Sales Showcase — synthetic data', switching: 'Switching…', failed: 'Could not change environment.' },
  fr: { legend: 'Environnement', main: 'Principal', mainHint: 'Les données réelles de votre organisation', demo: 'Démo', demoHint: 'Vitrine commerciale — données fictives', switching: 'Changement…', failed: 'Impossible de changer d’environnement.' },
}

/** Login-time choice between Main and Demo. Rendered only when the entry gateway is present. */
export const EnvironmentSelector: React.FC = () => {
  const { locale } = useI18n()
  const text = copy[String(locale).startsWith('fr') ? 'fr' : 'en']
  const [state, setState] = useState<EnvironmentState | null>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  useEffect(() => { void getEnvironment().then(setState) }, [])
  if (!state || state.available.length < 2) return null
  const choose = async (environment: AppEnvironment) => {
    if (environment === state.environment || busy) return
    setBusy(true); setError('')
    try { await setEnvironment(environment) } catch { setError(text.failed); setBusy(false) }
  }
  return (
    <fieldset className="stack" data-testid="environment-selector" aria-label={text.legend} style={{ border: '1px solid var(--border, #d0d5dd)', borderRadius: 8, padding: 12 }}>
      <legend>{text.legend}</legend>
      <div role="radiogroup" aria-label={text.legend} style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {(['main', 'demo'] as const).map(environment => (
          <button key={environment} type="button" role="radio" aria-checked={state.environment === environment} disabled={busy}
            data-testid={`environment-${environment}`} onClick={() => void choose(environment)}
            className={state.environment === environment ? 'btn btn-primary' : 'btn btn-secondary'} style={{ flex: '1 1 140px', textAlign: 'left' }}>
            <strong>{text[environment]}</strong><br /><small>{environment === 'main' ? text.mainHint : text.demoHint}</small>
          </button>
        ))}
      </div>
      {busy && <small role="status">{text.switching}</small>}
      {error && <small role="alert">{error}</small>}
    </fieldset>
  )
}
